import { Popconfirm, Tooltip } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { IS_DESKTOP } from "../../../core/constant";
// import Tooltip from "../tooltip/Tooltip";

export function MasterButton(props) {
    const [cursorOver, setCursorOver] = useState(false);
    
    return (
      <>
      { IS_DESKTOP ? <Tooltip placement={props.tooltipPlacement ? props.tooltipPlacement : undefined } visible={props.tooltip && cursorOver} getPopupContainer={(trigger) => {
        return trigger.parentNode
      }} title={props.tooltip}>
      <div
        onMouseOver={() => setCursorOver(true)}
        onMouseOut={() => setCursorOver(false)}
        className={props.style + " " + (props.disabled ? "disabled": "")}
        onClick={props.disabled ? undefined : props.onClick}
        onPointerDown={props.disabled ? undefined : props.onPointerDown}
        onPointerUp={props.disabled ? undefined : props.onPointerUp}
      >
        {props.icon}
        {props.title && (
          <p className={props.textStyle ? props.textStyle : `bitreel-viewer-text button-text`}>
            {props.title}
          </p>
        )}
      </div>
      </Tooltip> :       
      <div
        className={props.style}
        onClick={props.disabled ? undefined : props.onClick}
      >
        {props.icon}
        {props.title && (
          <p className={props.textStyle ? props.textStyle : `bitreel-viewer-text button-text`}>
            {props.title}
          </p>
        )}
      </div>}
      </>
    );
}